import { render } from "./SearchResultList.vue?vue&type=template&id=864847b6"
import script from "./SearchResultList.vue?vue&type=script&lang=js"
export * from "./SearchResultList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__